/**
 * Soft POC / closed alpha: when true, hide open Sign up and send people to /accept-invite.
 * Set `VITE_ALPHA_INVITE_REQUIRED=true` on Pages builds (matches API `ALPHA_INVITE_REQUIRED`).
 */
export function isAlphaInviteOnlyUi(env) {
    const value = env.VITE_ALPHA_INVITE_REQUIRED;
    return value === 'true' || value === '1' || value === true;
}
//# sourceMappingURL=alpha-invite-ui.js.map